import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import State from "slotworks/state-machine/states/state";

export default class ShowWinsSummary extends State {

    public static BIG_WINS: boolean = false;

    public onEnter(): void {
        const totalWin: number = GameState.getCurrentGame().getCurrentTotalWin();
        const stake: number = BetModel.getTotalStake();

        if (ShowWinsSummary.BIG_WINS && Components.bigWin.isBigWin(totalWin, stake)) {
            Components.bigWin.showWin(totalWin, stake).then(() => this.complete());
        } else if (totalWin > 0) {
            Components.celebrateWin.totalWin(totalWin).then(() => this.complete());
        } else {
            this.complete();
        }
    }
}
